// extracted by mini-css-extract-plugin
export default {"container":"ArtistCard_container__2BTZh","avatar":"ArtistCard_avatar__WX8oP","info":"ArtistCard_info__JR9Pp"};